export default "__VITE_ASSET__BlmuvmKw__"